export default {
  "wt-radio-button": "_wt-radio-button_1l0eeyj_1",
  "wt-radio-button__error-message": "_wt-radio-button__error-message_1l0eeyj_8",
  "wt-radio-button__input": "_wt-radio-button__input_1l0eeyj_14",
  "wt-radio-button__icon": "_wt-radio-button__icon_1l0eeyj_28",
  "wt-radio-button_theme_light": "_wt-radio-button_theme_light_1l0eeyj_43",
  "wt-radio-button_theme_dark": "_wt-radio-button_theme_dark_1l0eeyj_48",
  "wt-radio-button_size_m": "_wt-radio-button_size_m_1l0eeyj_53",
  "wt-radio-button_size_s": "_wt-radio-button_size_s_1l0eeyj_54",
  "wt-radio-button_size_xs": "_wt-radio-button_size_xs_1l0eeyj_60",
  "wt-radio-button__icon_error": "_wt-radio-button__icon_error_1l0eeyj_66",
  "wt-radio-button__label": "_wt-radio-button__label_1l0eeyj_73"
};